<template>
  <div class="calendar-comp">

    <div class="control">
      <span @click="calendarOffset(0,0)" v-if="calendarMode" class="arrow left"><i class="iconfont icon-zuojiantou"></i></span>
      <span @click="calendarOffset(0,1)" v-if="calendarMode" class="arrow right"><i
      class="iconfont icon-youjiantou"></i></span>
      <span @click="calendarOffset(1,0)" v-if="!calendarMode" class="arrow left"><i
      class="iconfont icon-zuojiantou"></i></span>
      <span @click="calendarOffset(1,1)" v-if="!calendarMode" class="arrow right"><i
      class="iconfont icon-youjiantou"></i></span>
      <span @click="toToday" class="calendarTitle"><i v-if="false" class="iconfont icon-plumage"></i>{{calendarPreview}}</span>

    </div>
    <span style="display: none">
          <button class="calendar-offset">月历-</button>
            <button class="calendar-offset">月历+</button>
            <button @click="toggleCalendar(0)">转月历</button>
            <button @click="toggleCalendar(1)">转周历</button>
            <button class="week-offset">周历-</button>
            <button class="week-offset">周历+</button>
                  <div class="dateshow" id="dateshow" ref="dateshow">2018-12-4</div>
            <div class="dateshow" id="dateRange">dateRange</div>

    </span>

    <div class="calendarContainer">
      <div id="calendarMain" class="calendar" :class="{'weekCalendar':calendarMode,'monthCalendar':!calendarMode}"
           ref="calendar">

      </div>
      <div class="monthShow">
        <p>{{weekViewMonth}}</p>
      </div>
    </div>

    <div @click="toggleCalendarMode" class="toggleBtn"><i class="iconfont"
                                                          :class="calendarMode?'icon-up':'icon-icon-shang'"></i></div>
    <div v-if="calendarMode" class="eventlist">
      <div class="weather-container">
        <span>{{getTodayDate}}
          <i>{{getTodayDateArr[1] + 1}}月</i>
        </span>
        <p class="simple">{{weather.overview}}</p>
        <p>{{weather.temperature}}</p>
      </div>
      <div @click="toScheduleDetail" class="toDetail">日程详情 ></div>
      <h2 v-if="currentSelectDateStr" class="selectDate">
        <i class="iconfont icon-richeng"></i>
        <span class="highlightDate">{{currentSelectDateStr}} 周{{currentSelectDateStrWeek}}</span>
      </h2>
      <h2 v-if="!currentSelectDateStr" class="selectDate">&nbsp;</h2>
      <ul v-if="scrollListData && currentSelectDateStr" class="todolist">

        <li class="empty" v-if="!currentDateSchListEmptyNotice" v-html="emptyScheduleListNotice"><br></li>


        <li v-if="item.solist.length" v-for="(item,index) in scrollListData">
          <general-scroll-list @clickItem="generalScrollListClickItem" :sort="item.type"
                               :scrollList="item.solist"></general-scroll-list>
        </li>

        <span v-if="false">
          <course-scroll-list @clickItem="clickItem" :courseList="currDateCourseList"></course-scroll-list>


        <li @click="toSchDealFlow(item)" v-if="item.sort!==6" v-for="item in currentDateSchList"><p><i class="iconfont"
                                                                                                       :class="item.iconClass"></i>{{item.title}}
        </p></li>
</span>
      </ul>

    </div>

  </div>
</template>

<script>
  import calendar from "common/js/calendar"
  import "common/stylus/calendar.css"
  //axios
  import axios from "axios"
  import apiConfig from 'common/js/api_config'
  import Bus from 'common/js/bus.js';

  import scrollTitle from 'components/globalComp/scrollTitle'
  //课程滚动组件
  import courseScrollList from 'components/course/courseScrollList'
  //通用滚动组件
  import generalScrollList from 'components/schedule/generalScrollList'
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';

  //公共函数
  function hasClass(elem, cls) {
    cls = cls || '';
    if (cls.replace(/\s/g, '').length == 0) return false; //当cls没有参数时，返回false
    return new RegExp(' ' + cls + ' ').test(' ' + elem.className + ' ');
  }

  function addClass(ele, cls) {
    if (!hasClass(ele, cls)) {
      ele.className = ele.className == '' ? cls : ele.className + ' ' + cls;
    }
  }

  function removeClass(elem, cls) {
    if (hasClass(elem, cls)) {
      var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, '') + ' ';
      while (newClass.indexOf(' ' + cls + ' ') >= 0) {
        newClass = newClass.replace(' ' + cls + ' ', ' ');
      }
      elem.className = newClass.replace(/^\s+|\s+$/g, '');
    }
  }

  export default {
    data() {
      return {

        /**
         * calendarMode
         * 0/false:月历
         * 1/true:周历
         */

        calendarMode: true,
        //当前是第几周
        todayWeek: 10,
        //日历对象
        calendarObj: calendar,
        //日历标题
        previewTitle: "",
        //当前选中的日期DOM
        currentSelectDate: null,
        //当前选中日期的字符串
        currentSelectDateStr: null,
        //当前视图的日程列表
        currentViewSchList: {},

        //天气
        weather: {
          overview: null,
          temperature: null
        },

        scrollTitleData: [],

        currDateCourseList: [],

        //滚动列表数据
        scrollListData: null,

        //周历当前月份
        weekViewMonth: null,


      }
    },
    methods: {
      convertDateToShort(dateStr) {
        //eg:convert 2019-1-3 to 2019-01-03
        let dateArr = dateStr.split("-");
        dateArr.forEach((item, index) => {
          dateArr[index] = parseInt(item);
        });
        dateStr = dateArr.join("-");
        return dateStr;
      },
      convertDateToLong(dateStr) {
        //eg:convert 2019-01-03 to 2019-1-3
        let dateArr = dateStr.split("-");
        dateArr.forEach((item, index) => {
          if (index === 0) {
            return;
          }
          dateArr[index] = this.padLeftZero(item);
        });
        dateStr = dateArr.join("-");
        return dateStr;
      },
      setDateDomToActive(dateStr, schList) {
        if (!calendar.getDateDOMByDateStr(this.convertDateToShort(dateStr))) {
          return;
        }
        let hasSchedule = false;
        try {
          schList.forEach((item) => {
            if (item.sort !== 6) {
              hasSchedule = true;
              throw 'hasSchedule:true'
            }
          })
        } catch (e) {
          console.log(e)
        }
        if (!hasSchedule) {
          return;
        }

        //console.log(`%c将日期设置为活跃状态：${dateStr}`,"color:#f60;font-size:20px")
        addClass(calendar.getDateDOMByDateStr(this.convertDateToShort(dateStr)), "event");
      },

      //***设置当前日历视图的日期状态[展示日程和校历数据]***
      async setCurrentViewDateState() {
        this.weekViewMonth = parseInt(calendar.currViewInfo.minDate[1])
        let startDate = this.getGeneralDateStr(calendar.currViewInfo.minDate);
        let endDate = this.getGeneralDateStr(calendar.currViewInfo.maxDate);

        let resDateInfo = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getSchedule?" + this.$qs.stringify({
          starttime: startDate,
          endtime: endDate
        }))
        let schList = resDateInfo.data.data[0];
        if (this.calendarMode) {
          this.previewTitle = resDateInfo.data.msg || '假期';
        }
        this.currentViewSchList = schList;
        for (let key in schList) {
          this.setDateDomToActive(key, schList[key])

          schList[key].forEach((item, index) => {
            if (item.sort === 6) {
              if (!calendar.getDateDOMByDateStr(this.convertDateToShort(key))) {
                return;
              }
              this.schoolCalInsertToDom(calendar.getDateDOMByDateStr(this.convertDateToShort(key)), item.title);
            }
          })
        }
        //自动触发点击
        let dom = calendar.getDateDOMByDateStr(this.convertDateToShort(this.getTodayCustomDateStr()))
        if (!dom) {
          calendar.getDateDOMByDateStr(this.convertDateToShort(calendar.currViewInfo.minDate.join('-'))).click()
        } else {
          dom.click()
        }

      },
      getScheduleType(id) {
        id = parseInt(id);
        let typeClass = "";
        switch (id) {
          case 0:
            typeClass = "icon-icon-";
            break;
          case 1:
            typeClass = "icon-ke";
            break;
          case 2:
            typeClass = "icon-hui";
            break;
          case 3:
            typeClass = "icon-shi";
            break;
          case 4:
            typeClass = "icon-yuyue";
            break;
          case 5:
            typeClass = "icon-yuyue1";
            break;
          case 6:
            typeClass = "icon-gezi";
            break;

          default:
            console.log("getScheduleType参数异常");
        }
        return typeClass;
      },
      dateclick() {

      },
      //获取今天字符串
      getTodayCustomDateStr() {
        let todayArr = calendar.gettodayinfo();
        let y = todayArr[0];
        let m = todayArr[1] + 1;
        let d = todayArr[2];
        return `${y}-${m}-${d}`
      },
      createCallBack() {
        this.setCurrentViewDateState();
        return

        //生成日历后自动点击今天【已废弃】
        setTimeout(() => {
          let dom = calendar.getDateDOMByDateStr(this.convertDateToShort(this.getTodayCustomDateStr()))
          if (dom) {
            dom.click()
          }
        }, 20)
      },
      toggleCalendar(calendarTypeId) {

      },
      padLeftZero: (str) => {
        str = str.toString();
        return ('00' + str).substr(str.length);
      },
      getGeneralDateStr(dateArr) {
        dateArr.forEach((item, index) => {
          if (index === 0) {
            return;
          }
          dateArr[index] = this.padLeftZero(item);
        });
        return dateArr.join("-");
      },
      setCalendarTitle() {

        if (this.calendarMode) {
          var previewInfo = this.calendarObj.previewWeekInfo;
          var prevWeek = this.todayWeek + calendar.currWeekOffset;
          if (prevWeek < 0) {
            this.previewTitle = `上学期`;
            return false;
          }


        } else {
          var previewInfo = this.calendarObj.getPreviewinfo();
          previewInfo[1] = previewInfo[1] + 1;
          this.previewTitle = previewInfo.join(this.calendarObj.sepsign);

        }

      },
      /**
       * true 向后 false 向前
       * @param way
       */
      calendarOffset(type, way) {
        if (type) {
          calendar.monthoffset(way);
        } else {
          calendar.weekCalendarOffset(way);
        }
        this.setCurrentViewDateState()
        this.setCalendarTitle();
        this.currentSelectDateStr = null;
      },

      toggleCalendarMode() {
        this.calendarMode = !this.calendarMode;
        if (this.calendarMode) {
          calendar.createWeek({
            dateclick: this.dateClickFunc,
            finishCB: this.createCallBack
          });
        } else {
          calendar.create({
            dateclick: this.dateClickFunc,
            finishCB: this.createCallBack
          });
        }
        this.setCalendarTitle();
        // this.toToday();
      },
      toToday: function () {
        // TODO:回到今天
        if (this.calendarMode) {
          this.calendarObj.toTodayWeek();
        } else {
          this.calendarObj.tododay();
        }
        this.setCalendarTitle();


        return false;
      },
      toScheduleDetail() {
        let currentSelectDateStr = this.currentSelectDateStr
        this.$modal.show("schedule", {currentSelectDateStr})
      },
      //将校历插入到如期DOM中
      schoolCalInsertToDom(dom, text) {
        addClass(dom, 'schoolCal');
        let schCalDom = document.createElement('p');
        schCalDom.innerHTML = text;
        dom.appendChild(schCalDom);
        dom.setAttribute('title', text)
      },
      //日程详情处理
      toSchDealFlow(schItem, schData) {
        let date;
        schItem.warn = parseInt(schItem.warn) ? 1 : 0
        if (schData) {
          date = schData
        } else {
          date = this.currentSelectDateStr
        }

        switch (schItem.sort) {
          case 0:
            //其他
            this.$modal.show("scheduleDetail", [schItem])
            break;
          case 1:
            //课程
            schItem.dateStr = this.convertDateToLong(this.currentSelectDateStr)
            this.$modal.show('courseTableModal', schItem)
            break;
          case 2:
            //会议
            this.$modal.show('meetingDetailModal', {info: schItem, date: date});
            break;
          case 3:
            //考试
            break;
          case 4:
            //预约（管理员）
            this.$modal.show('orderDetail', {info: schItem, date: date});
            break;
          case 5:
            //课程（用户）
            this.$modal.show('orderDetail', {info: schItem, date: date});
            break;
          default:
            //课程
            console.log('schItem.sort参数异常：' + schItem.sort)
            break;

        }

      },
      _initCourseData() {
        this.scrollListData = []
        setTimeout(async () => {
          let courseData = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getCourseList?day=' + this.convertDateToLong(this.currentSelectDateStr) + '&num=' + 1)
          let scrollList = courseData.data.data

          scrollList.forEach((item, index) => {
            this.scrollListData.push(item)
          })
          return
          courseData = courseData.data.data
          courseData.reverse()
          this.currDateCourseList = courseData
        }, 50)


      },
      //点击课程处理
      clickItem(item) {
        item.dateStr = this.convertDateToLong(this.currentSelectDateStr)
        this.$modal.show('courseTableModal', item)
      },
      //通用滚动列表点击列表项事件
      generalScrollListClickItem(ev) {
        let item = ev.item
        let type = ev.type
        item.sort = type
        let date = this.currentSelectDateStr
        this.toSchDealFlow(item, date)
      },
      //获取随机提示文案
      getRandomEmptyNoticeText() {
        let data = this.getEmptyNoticeText
        return data[parseInt(Math.random() * (data.length))].word
      }
    },
    watch: {
      async currentSelectDateStr(newVal, oldVal) {
        console.log(`currentSelectDateStr值变化：${oldVal}=>${newVal}`)
        if (!newVal) {
          return;
        }
        let weekInfo = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getSchollWeek?day=' + this.convertDateToLong(newVal))
        this.previewTitle = weekInfo.data.msg || '假期';
        this._initCourseData();


      }
    },
    mounted() {
      let self = this;
      let calendarContainer = this.$refs.calendar;
      let dateshowContainer = this.$refs.dateshow;
      console.log("calendarContainer")
      console.log(calendarContainer)

      calendar.calendar_container = calendarContainer;
      calendar.createWeek({
        dateclick: this.dateClickFunc,
        finishCB: this.createCallBack
      });

      //日历左右切换
      var aCalendarOperateBtn = document.getElementsByClassName("calendar-offset");
      for (var i = 0; i < aCalendarOperateBtn.length; i++) {
        aCalendarOperateBtn[i].setAttribute("idx", i);
        aCalendarOperateBtn[i].addEventListener("click", function () {
          calendar.monthoffset(parseInt(this.getAttribute("idx")));
        })
      }
      //周历左右切换
      var aCalendarOperateBtn = document.getElementsByClassName("week-offset");
      for (var i = 0; i < aCalendarOperateBtn.length; i++) {
        aCalendarOperateBtn[i].setAttribute("idx", i);
        aCalendarOperateBtn[i].addEventListener("click", function () {
          calendar.weekCalendarOffset(parseInt(this.getAttribute("idx")));
        })
      }
      this.setCalendarTitle();


      //日期事件委托
      calendarContainer.addEventListener("click", (ev) => {
        ev = ev || window.event;
        let target = ev.target || ev.srcElement;

        if (target.tagName === 'P') {
          target.parentNode.click();
          return;
        }

        if (target.getAttribute("class").indexOf("payload") !== -1) {

          let selectDomDateStr = target.getAttribute("datestr");
          console.log(selectDomDateStr);
          this.currentSelectDateStr = selectDomDateStr;
          if (selectDomDateStr.indexOf("false") !== -1) {
            console.log("异常");
            return false;
          }
          if (selectDomDateStr) {
            self.currentSelectDate ? removeClass(self.currentSelectDate, "selected") : "";
            self.currentSelectDate = target;
            addClass(target, "selected");
          }

        }
      });


      //注册通信总线的事件监听
      Bus.$on('refreshSchCalendar', (ev) => {
        this.toToday();
      });
      //注册通信总线的事件监听
      Bus.$on('toSchDetailFlow', (ev) => {
        let schData = ev.schData
        let schDate = ev.schData.time.split(' ')[0]
        this.toSchDealFlow(schData, schDate)
      });

      //初始化课程数据
      // this._initCourseData()

    },
    computed: {
      ...mapGetters(['getOneEmptyNoticeText', 'getEmptyNoticeText']),
      calendarPreview() {
        return this.previewTitle;
      },
      currentDateSchList() {
        if (!this.currentSelectDateStr) {
          return [];

        }
        let selDate = this.convertDateToLong(this.currentSelectDateStr);
        for (let date in this.currentViewSchList) {
          if (date === selDate) {
            this.currentViewSchList[date].forEach((item, index) => {
              this.currentViewSchList[date][index].iconClass = this.getScheduleType(item.sort)
            });
            console.log("this.currentViewSchList[date]", this.currentViewSchList[date])
            return this.currentViewSchList[date];
          }
        }
        return []

      },
      getTodayDate() {
        let todayDateObj = new Date();
        return todayDateObj.getDate();
      },
      //日程为空提示
      currentDateSchListEmptyNotice() {

        if (!this.scrollListData) {
          return false
        }
        for (let i = 0; i < this.scrollListData.length; i++) {
          if (this.scrollListData[i].solist.length) {
            return true
          }
        }
        return false;


        return

        //[旧的]
        if (!this.currentDateSchList.length && !this.currDateCourseList.length) {
          return true;
        }
        //判断课程
        if (this.currDateCourseList.length) {
          return false
        }

        let hasSchedule = false;
        this.currentDateSchList.forEach((item, index) => {
          if (item.sort !== 6) {
            hasSchedule = true;
          }
        })
        return !hasSchedule;
      },
      getTodayDateArr() {
        let date = new Date()
        let dateArr = []
        dateArr.push(date.getDate())
        dateArr.push(date.getMonth())
        dateArr.push(date.getFullYear())
        return dateArr
      },
      currentSelectDateStrWeek() {
        if (!this.currentSelectDateStr) {
          return null
        }
        let weekArr = ["日", "一", "二", "三", "四", "五", "六"]
        let date = new Date(this.currentSelectDateStr.replace(/-/g, '/'))

        return weekArr[date.getDay()]
      },
      //暂无日程文案
      emptyScheduleListNotice() {
        if (!this.currentSelectDateStr) {
          return
        }
        let today = calendar.gettodayinfo();
        today[1]++
        let todayStamp = new Date(today.join('/')).getTime()
        let selectDateStamp = new Date(this.currentSelectDateStr.replace(/-/g, '/')).getTime()
        let diffStamp = selectDateStamp - todayStamp
        //区分三种状态返回数据【今天之前】【今天当天】【今天之后】
        if (diffStamp === 0) {
          return this.getRandomEmptyNoticeText()
        } else if (diffStamp > 0) {
          return this.getRandomEmptyNoticeText()
        } else if (diffStamp < 0) {
          return this.getRandomEmptyNoticeText()
        } else {
          return '暂无日程'
        }
        return
      }
    },
    components: {scrollTitle, courseScrollList, generalScrollList}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .dateshow
    font-size 16px
    border 1px solid #eee
    width 100%
    height 40px

  .calendar-comp

    div.calendarContainer
      position relative

      .monthShow
        position absolute
        z-index 0
        top 0
        bottom 0
        left 0
        right 0

        & > p
          position absolute
          top 0
          bottom 0
          margin auto
          height 130px
          line-height 130px
          width 100%
          color #eef2fb
          font-size 130px
          text-align center

      div#calendarMain
        position relative
        background rgba(0, 0, 0, 0)
        z-index 2

    div#calendarMain.monthCalendar
      & >>> .row
        height 46px

        .col.payload
          background-color transparent !important
          color #666666

          &.schoolCal p
            color #666666
            overflow hidden
            white-space nowrap
            text-overflow ellipsis

          &.today
            background-color themeColor !important
            color #ffffff

            &.schoolCal p
              color #ffffff
              overflow hidden
              white-space nowrap
              text-overflow ellipsis

    .control
      height 36px

      .arrow
        display block
        width 30px
        height 100%
        line-height 36px
        text-align center
        transition 300ms
        cursor pointer

        &:hover
          background-color #eeeeee

        &.left
          float left

        &.right
          float right

        i
          font-size 12px

      .calendarTitle
        display block
        text-align center
        font-size 16px
        line-height 36px
        color #333333
        font-weight bold
        margin 10px 0

        i
          margin-right 10px
          transform-origin center center
          transform rotateZ(-30deg)

    & >>> .row
      height 50px
      padding-left 10px
      overflow hidden

      .col
        font-size 16px
        color #999999
        width 48px
        height 100%
        margin-right 3px
        line-height 46px
        user-select none


        &.payload
          cursor pointer

          &:hover
            background-color rgba(238, 238, 238, 0.52)

          &.selected
            color themeColor !important

            &.today
              color #ffffff !important

          &.event
            background-color rgba(128, 157, 191, 0.51)
            border-bottom 1px solid #ffffff
            border-top 1px solid #ffffff
            color #ffffff

            &.schoolCal p
              color #ffffff

          &.schoolCal
            /*line-height 35px*/
            p
              line-height 1
              font-size 12px
              position absolute
              left 0
              bottom 0px
              right 0
              text-align center
              /*transform scale(0.95)*/
              white-space: nowrap;
              color #333333
              text-overflow: ellipsis;
              overflow: hidden;


          &.today
            background-color themeColor
            color #ffffff
            border-radius 5px

            &.schoolCal p
              color #ffffff

    .toggleBtn
      display none
      width 100%
      height 35px
      line-height 35px
      text-align center
      border-top 1px solid #eeeeee
      border-bottom 1px solid #eeeeee
      margin 5px 0

    .eventlist
      margin-top 29px
      height 150px
      overflow hidden
      position relative

      .toDetail
        color themeColor
        font-size 16px
        z-index 9
        position absolute
        right 12px
        bottom 126px
        cursor pointer
        transition 300ms
        user-select none

        &:hover
          color themeColor

      .weather-container
        display none
        float left
        width 142px
        height 100%
        position relative

        & > span
          display block
          width 74px
          height 74px
          line-height 74px
          text-align center
          color #ffffff
          background-color #ffbb00
          position absolute
          left 0
          right 0
          margin auto
          top 18px
          border-radius 5px
          font-size 40px

          i
            font-size 12px
            line-height 1
            text-decoration none
            font-style normal
            /*border 1px solid #00f*/
            position absolute
            bottom 2px
            left 2px

        & > p
          font-size 12px
          color #666666
          text-align center
          margin-top 5px

        & > .simple
          margin-top 100px


      .selectDate
        position relative
        font-size 16px
        color #2b5c95
        margin-top 10px
        /*padding-left 10px*/
        text-indent 8px
        text-align center

        .highlightDate
          margin-right 5px
          font-size 16px
          font-weight bold
          color themeColor

        & > i

          position absolute
          top -3px
          left 8px
          //display inline-block
          display none
          font-size 16px
          float left
          color themeColor
          text-align center
          line-height 20px

      .todolist
        /*padding 0 18px*/
        float left
        width 100%
        height 100px
        overflow-y scroll
        margin-top 20px
        position relative

        li.empty
          text-align center
          font-size 18px
          color themeColor
          opacity 0.2

        li
          font-size 16px
          line-height 30px
          color #999999
          height 30px
          /*&::after*/
          /*content ""*/
          /*width 100%*/
          /*display block*/
          /*clear both*/

          &:nth-of-type(2n)
            width 100%
            background-color #f1f1f1

          p
            width 90%
            overflow hidden
            white-space nowrap
            text-overflow ellipsis
            line-height 37px
            transition 300ms
            cursor pointer

            &:hover
              color themeColor

            i
              vertical-align middle
              margin-right 3px
              color themeColor

          span
            float right
            font-size 12px
            color #cccccc
</style>



// WEBPACK FOOTER //
// src/components/schedule/calendar.vue